export const ROLE_USER = 1; //ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ
export const ROLE_MANAGER = 2; //ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¿Ð¾ Ð¿ÑÐ¾Ð´Ð°Ð¶Ð°Ð¼
export const ROLE_ACCOUNTANT = 3; //ÐÑÑÐ³Ð°Ð»ÑÐµÑ
export const ROLE_LOGIST = 4; //ÐÐ¾Ð³Ð¸ÑÑ ÐÐ¦
export const ROLE_ADMIN = 5; //ÐÐ´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾Ñ
export const ROLE_NOTARY = 6; //ÐÐ¾ÑÐ°ÑÐ¸ÑÑ
export const ROLE_ROP = 7; //Ð ÐÐ
export const ROLE_DIRECTOR = 9; //ÐÐ¸ÑÐµÐºÑÐ¾Ñ ÐÐ¦
export const ROLE_FINANCE = 10; //Ð¤Ð¸Ð½Ð°Ð½ÑÐ¸ÑÑ
export const ROLE_MOP = 12; //ÐÐÐ

export const ROLES = {
  [ROLE_USER]: 'ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ',
  [ROLE_MANAGER]: 'ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¿Ð¾ Ð¿ÑÐ¾Ð´Ð°Ð¶Ð°Ð¼',
  [ROLE_ACCOUNTANT]: 'ÐÑÑÐ³Ð°Ð»ÑÐµÑ',
  [ROLE_LOGIST]: 'ÐÐ¾Ð³Ð¸ÑÑ ÐÐ¦',
  [ROLE_ADMIN]: 'ÐÐ´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾Ñ',
  [ROLE_NOTARY]: 'ÐÐ¾ÑÐ°ÑÐ¸ÑÑ',
  [ROLE_ROP]: 'Ð ÐÐ',
  [ROLE_DIRECTOR]: 'ÐÐ¸ÑÐµÐºÑÐ¾Ñ ÐÐ¦',
};

export const PERMISSION_CAN_CREATE_LEADS = 1; //ÐÐ¾Ð¶ÐµÑ ÑÐ¾Ð·Ð´Ð°Ð²Ð°ÑÑ Ð»Ð¸Ð´Ñ
export const PERMISSION_CAN_EDIT_DEALS = 2; //ÐÐ¾Ð¶ÐµÑ Ð¸Ð·Ð¼ÐµÐ½ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸
export const PERMISSION_CAN_CHANGE_STATUSES = 3; //ÐÐ¾Ð¶ÐµÑ Ð¼ÐµÐ½ÑÑÑ ÑÑÐ°ÑÑÑÑ
export const PERMISSION_CAN_ASSIGN_MANAGER = 4; //ÐÐ°Ð·Ð½Ð°ÑÐ°ÑÑ Ð´ÑÑÐ³Ð¾Ð³Ð¾ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°
export const PERMISSION_CAN_SEE_ALL_DEALS = 5; //ÐÐ¾Ð¶ÐµÑ Ð²Ð¸Ð´ÐµÑÑ Ð²ÑÐµ ÑÐ´ÐµÐ»ÐºÐ¸
export const PERMISSION_CAN_DELETE_DEALS = 6; //ÐÐ¾Ð¶ÐµÑ ÑÐ´Ð°Ð»ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸
export const PERMISSION_CAN_SEE_ALL_LEADS = 7; //ÐÐ¾Ð¶ÐµÑ Ð²Ð¸Ð´ÐµÑÑ Ð²ÑÐµ Ð»Ð¸Ð´Ñ
export const PERMISSION_CAN_SEE_SERVICES = 8; //ÐÐ¾Ð¶ÐµÑ Ð²Ð¸Ð´ÐµÑÑ ÑÑÐ»ÑÐ³Ð¸
export const PERMISSION_CAN_SEE_RECORDS = 10; //ÐÐ¾Ð¶ÐµÑ Ð²Ð¸Ð´ÐµÑÑ Ð·Ð°Ð¿Ð¸ÑÐ¸
export const PERMISSION_CAN_SEE_REPORTS = 11; //ÐÐ¾Ð¶ÐµÑ Ð²Ð¸Ð´ÐµÑÑ Ð¾ÑÑÐµÑÑ
export const PERMISSION_CAN_SEE_PERMISSIONS = 9; //ÐÐ¾Ð¶ÐµÑ Ð²Ð¸Ð´ÐµÑÑ Ð¿ÑÐ°Ð²Ð° Ð´Ð¾ÑÑÑÐ¿Ð°
export const PERMISSION_CAN_EDIT_AUTO_AND_EQUIPMENTS = 12; //ÐÐ¾Ð¶ÐµÑ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð°Ð²ÑÐ¾ Ð¸ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ
